import {EtsyList, EtsyShippingProfile} from '@coolcolduk/etsy';
import getAxios from '../../util/axios/getAxios';

export default async function fetchShopShippingProfiles(
  token: string,
  shopRecordId: string,
): Promise<EtsyList<EtsyShippingProfile>> {
  const response = await getAxios('etsy', {token}).get<EtsyList<EtsyShippingProfile>>('getShopShippingProfiles', {
    params: {shopRecordId},
  });
  return response.data;
}
